import { KatButton, KatIcon } from "@amzn/katal-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { TestStatus } from "src/api/interfaces/nest";
import type { NestTestResult } from "src/api/interfaces/nest/history";
import { NestStatusBadge } from "../../NestStatusBadge";
import { NestHistoryErrorTable } from "../NestHistoryErrorTable";
import "./index.css";
import { useNest } from "src/components/Contexts/NestContext";

interface NestHistoryDetailProps {
  test: NestTestResult;
  onBack: () => void;
  onNewTest: (useCaseId: string) => void;
}

export function NestHistoryDetail({
  test,
  onBack,
  onNewTest,
}: NestHistoryDetailProps) {
  const { t } = useTranslation();
  const passed = test.status === TestStatus.PASS;
  const { partnerCode } = useNest();

  return (
    <>
      <div className="nest-detail-header">
        <KatButton variant="link" size="small" onClick={onBack}>
          <KatIcon name="chevron-left" size="small" />
        </KatButton>
        <p className="nest-detail-header-title">
          {t("nest_history_detail_title", { fileName: test.fileName })}
        </p>
      </div>
      <div className="nest-detail-content">
        <div
          className={`nest-detail-status nest-detail-status--${passed ? "passed" : "failed"}`}
        >
          <NestStatusBadge status={test.status} />
          <p className="nest-detail-message">
            {passed
              ? t("nest_history_detail_passed")
              : t("nest_history_detail_validation_summary", {
                  total: test.totalValidations,
                  passed: test.totalValidations - test.failedValidations,
                })}
          </p>
        </div>
        {test.errors?.length > 0 && (
          <div className="nest-detail-error-list">
            <h6 className="nest-detail-error-list-title">
              {t("nest_history_detail_errorList")}
            </h6>
            <div className="nest-detail-error-table-container">
              <NestHistoryErrorTable data={test.errors} />
            </div>
          </div>
        )}
        <div className="nest-detail-actions">
          <KatButton
            variant="tertiary"
            onClick={() => onNewTest(test.useCaseId)}
            disabled={!!partnerCode}
          >
            <KatIcon name="description" size="small" />
            <span>{t("nest_history_detail_newTest")}</span>
          </KatButton>
        </div>
      </div>
    </>
  );
}
